var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"influence-icon",style:(_vm.offsetStyle),attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }